(function () {
  'use strict';

  var INTERVAL_MS = 3000;

  function getPerView() {
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (w <= 749) return 1;
    if (w <= 989) return 2;
    return 3;
  }

  function initSlider(slider) {
    if (slider.dataset.taupeSocialInit === 'true') return;
    slider.dataset.taupeSocialInit = 'true';

    var track = slider.querySelector('[data-taupe-social-track]');
    var prevBtn = slider.querySelector('[data-taupe-social-prev]');
    var nextBtn = slider.querySelector('[data-taupe-social-next]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    var count = originals.length;
    if (count < 1) return;

    var perView = getPerView();
    var index = 0;
    var timer = null;
    var animating = false;
    var clones = [];

    function removeClones() {
      clones.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
      clones = [];
    }

    function canLoop() {
      return count > 1;
    }

    function cardStep() {
      var card = track.querySelector('.taupe-social-proof__card');
      if (!card) return 0;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function setTransform(withTransition) {
      track.style.transition = withTransition ? '' : 'none';
      track.style.transform = 'translate3d(-' + (index * cardStep()) + 'px, 0, 0)';
      if (!withTransition) {
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    function build() {
      perView = getPerView();
      removeClones();
      track.style.setProperty('--taupe-social-per-view', perView);

      if (canLoop()) {
        var i;
        for (i = 0; i < perView; i++) {
          var tail = originals[i % count].cloneNode(true);
          tail.setAttribute('aria-hidden', 'true');
          tail.dataset.taupeClone = 'true';
          track.appendChild(tail);
          clones.push(tail);
        }
        for (i = 0; i < perView; i++) {
          var head = originals[(count - 1 - (i % count) + count) % count].cloneNode(true);
          head.setAttribute('aria-hidden', 'true');
          head.dataset.taupeClone = 'true';
          track.insertBefore(head, track.firstChild);
          clones.push(head);
        }
        index = perView;
      } else {
        index = 0;
      }
      setTransform(false);
    }

    function goNext() {
      if (animating || !canLoop()) return;
      animating = true;
      index += 1;
      setTransform(true);
    }

    function goPrev() {
      if (animating || !canLoop()) return;
      animating = true;
      index -= 1;
      setTransform(true);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      if (canLoop()) {
        timer = window.setInterval(goNext, INTERVAL_MS);
      }
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      animating = false;
      if (!canLoop()) return;
      if (index >= count + perView) {
        index -= count;
        setTransform(false);
      } else if (index < perView) {
        index += count;
        setTransform(false);
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goPrev();
        restart();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goNext();
        restart();
      });
    }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', restart);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', restart);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var nextPerView = getPerView();
        if (nextPerView !== perView) {
          build();
          restart();
        } else {
          setTransform(false);
        }
      }, 150);
    });

    build();
    restart();
  }

  function initSocialSliders() {
    document.querySelectorAll('[data-taupe-social-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialSliders);
  } else {
    initSocialSliders();
  }

  document.addEventListener('shopify:section:load', initSocialSliders);
})();
